"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = __importDefault(require("../i18n"));
const { get, mergeWith } = require('lodash');
const mergeHandler = (srcValue, objValue) => {
    if (Array.isArray(objValue) && !Array.isArray(srcValue) && srcValue) {
        return srcValue;
    }
};
class Base {
    constructor(data) {
        this.metadata = {};
        this.id = -1;
        this.language = 'en';
        this.selfMerge(data);
    }
    selfMerge(data) {
        if (!data)
            return;
        if (typeof data.metadata === 'string')
            data.metadata = JSON.parse(data.metadata);
        if (data.metadata === null)
            data.metadata = {};
        mergeWith(this, data, mergeHandler);
    }
    is(value) {
        return Number(value) === Number(this.id);
    }
    matchId(id) {
        return id === this.id;
    }
    t(key, defValue) {
        return get(i18n_1.default, `${this.language}.${key}`, defValue !== null && defValue !== void 0 ? defValue : key);
    }
}
exports.default = Base;
